var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chart",staticClass:"power-load-chart",attrs:{"role":"img","aria-label":"当前配电房日内负荷；10:22之后无采样"}})
}
var staticRenderFns = []

export { render, staticRenderFns }